import type React from "react";
import { ItemIconChain } from "@similarweb/ui-components";
import type { favicon } from "app/services/sitesService/types";
import { IconWrapper, TopIconContainer, BottomIconContainer, ExtraItemsCountWrapper } from "./styledComponents";

interface IDiverseItemIconProps {
    mainItem: favicon;
    extraItemsCount: number;
}

export const DiverseItemIcon: React.FC<IDiverseItemIconProps> = (props) => {
    return (
        <IconWrapper>
            <TopIconContainer>
                <ItemIconChain
                    icons={[props.mainItem]}
                    size={20}
                    maxIconChain={1}
                />
            </TopIconContainer>
            <BottomIconContainer>
                <ExtraItemsCountWrapper>
                    <ItemIconChain
                        icons={[...Array(props.extraItemsCount - 1)]}
                        size={20}
                        maxIconChain={0}
                    />
                </ExtraItemsCountWrapper>
            </BottomIconContainer>
        </IconWrapper>
    );
};
